import * as authSelectors from "@rentiohq/shared-frontend/dist/redux/auth/auth.selectors";
import * as contactActions from "@rentiohq/shared-frontend/dist/redux/contact/contact.actions";
import { EContactCustomId } from "@rentiohq/shared-frontend/dist/redux/contact/contact.types";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { IRootState } from "../redux/reducers";

const withAuthenticationCheck = (Component: any) => {
  const WithAuthenticationCheck = (props: any) => {
    const dispatch = useDispatch();

    const hasAccessToken = useSelector((state: IRootState) =>
      authSelectors.hasAccessToken(state),
    );
    const user = useSelector((state: IRootState) =>
      authSelectors.getUser(state),
    );

    React.useEffect(() => {
      if (!hasAccessToken) {
        return;
      }

      dispatch(
        contactActions.getContact.actions.start({
          contactId: EContactCustomId.Me,
        }),
      );

      dispatch(
        contactActions.getContact.actions.start({
          contactId: EContactCustomId.MeMaster,
        }),
      );
    }, [hasAccessToken]);

    const { unverifiedEmail, unverifiedPhone, unverifiedPhoneIsVerifiable } =
      user || {};

    const renderRedirect = (pathname: string) => (
      <Navigate
        to={{
          pathname,
        }}
        state={{
          referrer: `${window.location.pathname}${window.location.search}`,
        }}
      />
    );

    // Render
    if (unverifiedEmail) {
      return renderRedirect("/auth/verify/email");
    }

    if (unverifiedPhone && unverifiedPhoneIsVerifiable) {
      return renderRedirect("/auth/verify/phone");
    }

    if (!hasAccessToken || !user) {
      return renderRedirect("/auth/signin");
    }

    return <Component {...props} />;
  };

  return WithAuthenticationCheck;
};

// eslint-disable-next-line import/no-default-export
export default withAuthenticationCheck;
